import React from 'react';
import { Avatar } from '@mui/material';
import { UserAdministrationInfo } from '../common/interfaces/common.interface';

import { palette } from '../theme';
/**
 * The signed-in user's picture, or their initials when there is none.
 *
 * Initials are #3f3273 on #c0b6e0 (5.75:1). The old #9747ff fill read at only 2.43:1
 * against the sidebar, so it is gone.
 */
const UserAvatar: React.FC<{ user?: UserAdministrationInfo['user']; size?: number }> = ({ user, size = 40 }) => {
  const initials = `${user?.firstName?.charAt(0) ?? ''}${user?.lastName?.charAt(0) ?? ''}`.toUpperCase();
  return (
    <Avatar
      src={user?.profilePicture || undefined}
      // the name is always next to it, or in a tooltip, so the picture itself adds nothing
      alt=""
      sx={{
        width: size,
        height: size,
        flex: 'none',
        fontSize: 16,
        fontWeight: 600,
        color: palette.sidebar.main,
        bgcolor: palette.lavender.main
      }}
    >
      {initials || null}
    </Avatar>
  );
};

export default UserAvatar;
